import React from "react";
import {
    USER_STATE,
    DEFAULT_DEBOUNCE_TIMEOUT,
    DEFAULT_PAGE,
    DEFAULT_MEDIUM_FETCHED_OPTIONS,
} from "consts";
import { getTasks } from "api";
//
import { AutoSuggest } from "containers/components/autoSuggest";

const TaskAutoSuggest = (props) => {
    return (
        <AutoSuggest
            label="Task"
            disabled={!props.project}
            arg={props.project && props.project.Id}
            fetchOptions={(q, projectId) =>
                getTasks(projectId, q, props.taskState, null, DEFAULT_PAGE, DEFAULT_MEDIUM_FETCHED_OPTIONS, null, null, true)
                    .then(value => value.content)
            }
            renderOption={(task) => ({
                label: `${task.Name} - ${task.Summary}` + (task.Closed ? ' (Closed)' : ''),
                value: task
            })}
            optionIdentifier={(task) => task.Id}
            debounceTimeout={DEFAULT_DEBOUNCE_TIMEOUT}
            {...props}
        />
    );
}

TaskAutoSuggest.defaultProps = {
    taskState: USER_STATE.ACTIVE,
}

export default TaskAutoSuggest;
